/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindAllQueryResponse, DocumentsControllerFindAllQueryParams, DocumentsControllerFindAll401, DocumentsControllerFindAll403 } from "../../models/documentsController/DocumentsControllerFindAll";

function getDocumentsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/documents` as const }  
  return res
}

/**
 * @summary Get all documents
 * {@link /api/v1/documents}
 */
export async function documentsControllerFindAll(params?: DocumentsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerFindAllQueryResponse, ResponseErrorConfig<DocumentsControllerFindAll401 | DocumentsControllerFindAll403>, unknown>({ method : "GET", url : getDocumentsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}